export default class ModuleTwoService {
  
  static getAmountOfFoodAid(foodAid){
    if (!foodAid || !foodAid.has)
      return 0

    return (foodAid.mealByDay * foodAid.daysByMonth * foodAid.value)
  }
  /**
   * @param {Number} amountOfModuleOne 
   * @param {Object} moduleTwo 
   */
  static getAmountOfModuleTwoOne(amountOfModuleOne, moduleTwo){
    let thirteenFirstSalary = amountOfModuleOne * moduleTwo.thirteenFirstSalary / 100;
    let vacationAdditional  = amountOfModuleOne * moduleTwo.vacationAdditional / 100;
    return thirteenFirstSalary + vacationAdditional
  }
  /**
   * @param {Number} moduleOneAndModuleTwoOne 
   * @param {Object} moduleTwo 
   */
  static getAmountOfModuleTwoTwo(moduleOneAndModuleTwoOne, moduleTwo){
    let amountOfPercents = this.getAmountOfModuleTwoTwoPercents(moduleTwo)

    return moduleOneAndModuleTwoOne * amountOfPercents / 100
    
  }
  static getAmountOfModuleTwoThree(basicSalaryCCT, moduleTwo){
    return this.getAmountOfTransport(basicSalaryCCT, moduleTwo.transport) +
           this.getAmountOfFoodAid(moduleTwo.foodAid) +
           this.getOthers(moduleTwo.others);
  }
  
  static getAmountOfModuleTwoOnePercents(moduleTwo){
    return moduleTwo.thirteenFirstSalary + moduleTwo.vacationAdditional
  }

  static getAmountOfModuleTwoTwoPercents(moduleTwo){
    return moduleTwo.inss +
            moduleTwo.fgts +
            moduleTwo.sesiSesc +
            moduleTwo.senaiSenac +
            moduleTwo.incra +
            moduleTwo.sebrae +
            moduleTwo.educationSalary +
            (moduleTwo.rat * moduleTwo.fap)
  }
  static getOthers(others){
    if(!others)
      return 0
    let amount = 0
    for (let i = 0; i < others.length; i++) {
      amount += others[i].value;
    }
    return amount
  }
  static getAmountOfTransport(basicSalaryCCT, transport){
    // só faz o cálculo caso use vale transporte, ou seja, a quantidade de vale por dia e
    // a quantidade de dias úteis forem maiores do que zero
    if (!transport || !transport.has)
      return 0
    
    let partialAmount = this.getPartialAmountOfTransport(transport)
    
    if ( partialAmount <= 0)
      return 0

    let employeeCost = this.getEmployeeCost(basicSalaryCCT)
  
    return partialAmount - employeeCost

  }
  static getEmployeeCost(basicSalaryCCT){
    return basicSalaryCCT * 6 / 100;
  }
  static getPartialAmountOfTransport(transport){
    if (!transport)
      return 0
    
    let partialAmount = 0
    if ( transport.tariffValue > 0 && transport.ticketByDay > 0 && transport.daysByMonth > 0)
      partialAmount = transport.tariffValue * transport.ticketByDay * transport.daysByMonth
    
    return partialAmount
  }
} // class



// WEBPACK FOOTER //
// ./src/service/ModuleTwoService.js